import { matchPath } from 'react-router'

import { isNotNull, isNotUndefined } from '@hcr/utils'

export const isSamePath =
  (path1: string | undefined) =>
  (path2: string | undefined): boolean =>
    isNotUndefined(path1) && isNotUndefined(path2) && isNotNull(matchPath(path1, path2))
